import createReactComponent from '../createReactComponent';
export default createReactComponent('search-minus', 'SearchMinus', [["path",{"d":"M9.5 11.5h4m5.5 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0m-2.107 5.42 3.08 3.08","key":"svg-0"}]]);